import api from '@/api';
import { API_BASE_URL } from '..';
import { WorkOrderChecklistDamage } from '../WorkOrdersChecklist/WorkOrdersChecklist.types';
import { OldChecklistParams } from './WorkorderOldChecklists.services';

const CONTROLLER_URL = `${API_BASE_URL}/OldChecklist`;

export async function oldChecklistDamages(params: OldChecklistParams) {
  const resut = (await api.get(
    `${CONTROLLER_URL}/getDamage`,
    params,
  )) as unknown;

  return resut as WorkOrderChecklistDamage[];
}
